import type { ReactNode } from 'react';
import React from 'react';

import Footer from 'v2/components/Shared/Footer';

import Header from './Header';

interface IProps {
  children: ReactNode;
}

const UnloggedLayout = ({ children }: IProps) => {
  return (
    <>
      <div className='eduzz-ui-layout-topbar'>
        <Header />
      </div>
      <div className='relative z-3 min-h-full'>
        <div className='relative mx-auto min-h-full w-full max-w-360 px-8 pt-8 pb-4 max-sm:p-4'>{children}</div>
      </div>
      <img className='mx-auto mb-4 block' src='/img/faded-logo.svg' alt='Eduzz Logo' />
      <Footer hideQuickHelp />
    </>
  );
};
export default UnloggedLayout;
